import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {
  GetGlobalConfigurationDto
} from "../../auto-generated-server-dtos/adjuster/configuration/get-global-configuration-dto";

@Injectable({
  providedIn: 'root'
})
export class GetGlobalConfigurationService {

  constructor(private httpClient: HttpClient) { }

  getGlobalConfiguration() {
    return this.httpClient.get<GetGlobalConfigurationDto>(`${environment.apiServer}/Adjuster/Configuration/GetGlobalConfiguration`);
  }
}
